import { useContext } from 'react'
import { useLocalStorage } from '@rehooks/local-storage'
import { ConnectedUser } from '@ucc/admin-global-state'
import { Roles } from '@ucc/unified-admin-common'

import { ConnectedUserContext } from '../components'
import config from '../config'

const useUserHasOnlyBillingAdminRoles = () => {
  const connectedUser = useContext(ConnectedUserContext)
  const [iAmInfos] = useLocalStorage<ConnectedUser>(config.I_AM_TOKEN_KEY)
  const currentUser = connectedUser ? connectedUser : iAmInfos

  const gtcBillingAdminRoles = [Roles.ViewInvoices, Roles.ViewAndPayInvoices]
  const hasOnlyGtcBillingAdminRoles = (roles: string[]): boolean =>
    roles.length > 0 && roles.every((role) => gtcBillingAdminRoles.includes(role))

  return (selectedAccountKey?: any): boolean => {
    if (selectedAccountKey) {
      const adminRoles = currentUser?.accounts?.find((account) => account.key === selectedAccountKey)?.adminRoles
      return hasOnlyGtcBillingAdminRoles(adminRoles || [])
    }
    return hasOnlyGtcBillingAdminRoles(currentUser?.adminRoles || [])
  }
}

export default useUserHasOnlyBillingAdminRoles
